import script from "./LootBoxBoxesBalance.vue?vue&type=script&setup=true&lang=js"
export * from "./LootBoxBoxesBalance.vue?vue&type=script&setup=true&lang=js"

import "./LootBoxBoxesBalance.vue?vue&type=style&index=0&id=7f1ead58&lang=scss"

const __exports__ = script;

export default __exports__